import { State } from 'app/gamma/src/modules';
import { AlertArea, AlertName } from 'app/gamma/src/modules/state/ui/alerts';

export const isAlertShown = (
  state: State,
  area: AlertArea,
  name: AlertName,
): boolean => {
  return area in state.ui.alerts && state.ui.alerts[area] === name;
};
